import React, { useState } from 'react';
import { Container, Badge, Spinner, Button, OverlayTrigger, Popover, Modal } from 'react-bootstrap';
import { Table } from '../../components/DataTable';
import dayjs from "dayjs";
import { Column } from 'react-table';
import { useAsyncRetry } from 'react-use';
import api from '../../api';
import { asset, invType } from '../../api/newApi/getOnhand';
import OrderModel from '../../components/OrderModel';
import AleartModel from '../../components/AleartModel';
import ShareModel from '../../components/ShareGuideModel';
import { FacebookShare, LineShare, Bell } from '../../icons/';
import { toast } from 'react-toastify';
import SchoolCampaignReminder from '../../components/SchoolCampaignReminder';


import {
  FacebookShareButton,
  LineShareButton,
} from "react-share";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classNames from 'classnames/bind';
import style from './index.module.css';

const cx = classNames.bind(style);

export interface AccountProps {
  cuid: string,
  code: string | null,
  campaignName: string | null;
  userName: string,
  refreshTime: string;
  sessionId: string | null;
  mtype: string;
  handleOninvitationCode: (code: string | null) => void,
  invitationCode: string | null;
  campaign_active: boolean;
  continueBell: () => void;
  joinSC: boolean;
}

function useOnhandInfo(cuid: string) {
  const { loading, value, retry } = useAsyncRetry(() => api.getOnhandQuery({ cu_id: cuid }), []);
  const asset = React.useMemo(() => {
    const assetInfo = [{ csh: value?.csh || 0, stk: value?.stk || 0, nat: value?.nat || 0, pf: value?.pf || 0, roi: value?.roi || 0 }]
    return assetInfo;
  }, [loading]);
  const inv = React.useMemo(() => {
    return value?.inv ? value?.inv : []
  }, [loading]);

  const queryTime = value?.QueryTime ? value?.QueryTime : ""
  return {
    retry,
    loading,
    asset,
    inv,
    queryTime
  };
}

function useInvitationQuery(cuid: string | null) {
  const { loading, value } = useAsyncRetry(() => api.invitationQuery({ cu_id: cuid }), [cuid]);
  const invitation = React.useMemo(() => {
    if (!cuid) { return "請選擇活動"; }
    return value?.inv_code ? value?.inv_code : null;
  }, [loading]);

  return {
    loading,
    invitation,
  };
}

interface LastDayTipProps {
  sym: string;
  day: string;
  name: string;
  todayDate: string;
}

const LastDayTip: React.FC<LastDayTipProps> = ({
  day,
  name,
  todayDate,
  sym
}) => {
  function TipText() {
    if (Number(day) <= 10 && Number(day) > 1) {
      return <>今日(<span className={cx("tip")} >{todayDate}</span>)是您在模擬交易的庫存商品<span className={cx("tip")} >{name}</span>距到期日只剩<span className={cx("tip")} >{day}天</span>，權證是有到期日的，適合短線操作，不宜長期持有。</>
    }
    if (Number(day) === 1) {
      return <>今日({todayDate})是您在模擬交易的庫存商品<span className={cx("tip")}>{name}</span><span style={{ color: "red" }}>最後交易日</span>，請把握最後交易機會。</>
    }
    if (Number(day) <= 0) {
      return <>您在模擬交易的庫存商品<span className={cx("tip")} >{name}</span><span style={{ color: "red" }}>已到期</span>，以<span className={cx("tip")} >{todayDate}</span>到期結算價幫您計算損益。</>
    }
  }

  return (
    <OverlayTrigger
      trigger="click"
      key={sym}
      placement={"top"}
      rootClose
      overlay={
        <Popover id={`popover-positioned-${sym}`}>
          <Popover.Header as="h3">{`提醒您!`}</Popover.Header>
          <Popover.Body>
            {TipText()}
          </Popover.Body>
        </Popover>
      }
    >
      <span className={cx("Bell")}><Bell /></span>
    </OverlayTrigger>
  );
}

const Account: React.FC<AccountProps> = ({
  cuid,
  code,
  refreshTime,
  campaignName,
  userName,
  sessionId,
  mtype,
  handleOninvitationCode,
  invitationCode,
  campaign_active,
  continueBell,
  joinSC
}) => {
  const { loading: valueyLoading, invitation } = useInvitationQuery(cuid)
  const shareUrl = `${process.env.REACT_APP_URL}#/home?inviteCode=${invitation ? invitation : ""}`
  const title = '歡迎一起參加權證模擬交易抽大獎,我的邀請碼:' + `${invitation}`;
  const showTip = (window.parent as any).location.href.includes("tradSchoolCampaign");
  const [show, setShow] = useState(false);
  const [showinviteModel, setShowinviteModel] = useState(false);
  const [istop6K, setIstop6K] = useState<boolean | null>(null);

  const [symCnName, setSymCnName] = useState<string>("");
  const [sym, setSym] = useState<string>("");
  const [bS1, setBS1] = useState<"B" | "S" | null>(null);
  const [p1, setP1] = useState<number | null>(null);
  const [qty, setQty] = useState<number>(1);
  const [tif, setTif] = useState<"R" | "F" | "I" | null>(null);
  const [ort, setOrt] = useState<"1" | "2" | null>(null);
  const [togget, setTogger] = useState<boolean>(false)
  const [t1, setT1] = useState<string>(dayjs().format("YYYY/MM/DD HH:mm:ss.000"))
  const [t2, setT2] = useState<string>("")
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);

  // 母股漲停
  const [t_up_stop, setT_up_stop] = useState<number | null>(null)
  // 母股跌停
  const [t_down_stop, setT_down_stop] = useState<number | null>(null)
  //母股現價
  const [target_money, setTarget_money] = useState<string>('')

  const [openAlertModel, setOpenAlertModel] = useState<boolean>(false)
  const [alertType, setAlertType] = useState<"income" | "reset" | null>(null)
  React.useEffect(() => {
    handleOninvitationCode(invitation);
    (window.parent as any).resizeIframe()
  }, [invitation])
  //用localStorage 儲存判斷 是否第一次進入的彈窗  （ 不需要入金重製的彈窗 ）
  React.useEffect(() => {
    if (campaignName === "權校大比拚") {
      const hasSeenModal = localStorage.getItem('hasSeenWelcomeModal');
      // 檢查是否已經顯示過彈窗
      if (!hasSeenModal) {
        setShowWelcomeModal(true);
      }
    }
  }, [campaignName]);

    // 當關閉彈窗時，將狀態儲存至 localStorage
    const handleCloseWelcomeModal = () => {
      setShowWelcomeModal(false);
      localStorage.setItem('hasSeenWelcomeModal', 'true');
    };

  const handleClose = () => {
    setShow(false);
    setSymCnName("");
    setSym("");
    setBS1(null);
    setP1(null);
    setQty(1);
    setTif(null);
    setOrt(null);
    (window.parent as any).showBanner(1);
    setTimeout(() => {
      (window.parent as any).scrollTo({
        top: 0,
        behavior: 'smooth',
        scrollBehavior: 'smooth'
      });
    }, 100)
  };

  const handleOpenAlert = (type: "income" | "reset" | null) => {
    setAlertType(type)
    setOpenAlertModel(true)
  };

  const handleAlert = () => {
    if (alertType === "income") {
      api.deposit({ cu_id: cuid }).then(() => retry())
    }
    if (alertType === "reset") {
      cuid && api.accountReset({ cu_id: cuid }).then(() => retry())
    }

    setAlertType(null)
    setOpenAlertModel(false)
  };

  const handleOrder = (row: any, BS: "B" | "S") => {
    const t1 = dayjs().subtract(5, 'second').format("YYYY/MM/DD HH:mm:ss.000");
    const t2 = dayjs().format("YYYY/MM/DD HH:mm:ss.000");
    setT1(t1);
    setT2(t2);
    if (!campaign_active) {
      api.bellCheck({ cu_id: cuid, t1: t1, t2: t2 }).then((e) => {
        if (e?.err === "1200") {
          toast.warn('非系統交易時間！', {
            position: "top-right",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          (window.parent as any).scrollTo({
            top: 11,
            behavior: 'smooth',
          });
          return;
        } else {
          continueBell();
          setShow(true);
          setSymCnName(row.name);
          setSym(row.sym);
          setP1(row.pc);
          setOrt("2");
          setTif("R");
          setBS1(BS);
          setT_up_stop(row.t_up_stop);
          setT_down_stop(row.t_down_stop);
          setTarget_money(row.t_money);
          (window.parent as any).showBanner(0);
          (window.parent as any).scrollTo({
            top: 11,
            behavior: 'smooth',
          });
        }
      })
    } else {
      setShow(true);
      setSymCnName(row.name);
      setSym(row.sym);
      setP1(row.pc);
      setOrt("2");
      setTif("R");
      setBS1(BS);
      setT_up_stop(row.t_up_stop);
      setT_down_stop(row.t_down_stop);
      setTarget_money(row.t_money);
      (window.parent as any).showBanner(0);
      (window.parent as any).scrollTo({
        top: 11,
        behavior: 'smooth',
      });
    }
  };

  const handlePrice = (price: number) => {
    setP1(price)
    setOrt("2")
  };

  const handlePriceType = (type: "1" | "2" | null) => {
    setOrt(type)
    if (type === "1") {
      setP1(0)
    }
  };
  const handleOrderPlace = () => {
    if (!bS1 || !tif || !ort || p1 == null) {
      toast.warn('請填妥下單條件', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }
    if (ort === "2" && (!p1 || Number(p1) <= 0 || p1 <= 0)) {
      toast.warn('限價單請輸入價格', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return
    }

    api.OrderPlace({
      cu_id: cuid,
      src: "WEB",
      sym: sym,
      bS1: bS1,
      p1: p1,
      qty: qty,
      tif: tif,
      ort: ort,
      icc: invitationCode === null ? "1" : "0",
    }).then((e) => {
      handleClose()
    })
  };
  
  React.useEffect(() => {
    if ((istop6K !== null) && invitationCode === null) setShowinviteModel(true)
  }, [istop6K, invitationCode])
  const { loading: OnhandLoading, inv: invDate, asset: assetDate, retry, queryTime } = useOnhandInfo(cuid)
  const todayDate = dayjs().format("YYYY/MM/DD");
  const numberFormatter = (value: string) =>
    (+value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  React.useEffect(() => {
    const everySecond = 60
    const creatInt = setInterval(() => {
      if (campaign_active) { retry() }
      setTogger(!togget)
    }, everySecond * 1000);
    return () => {
      clearInterval(creatInt);
    };
  }, [togget])

  const user_status_columns = React.useMemo<Column<asset>[]>(
    () => [
      {
        Header: "現金資產",
        accessor: "csh",
        sticky: "left",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div>{numberFormatter(cellInfo.cell.row.original.csh.toString())}</div>}
        </>
      },
      {
        Header: "權證資產",
        accessor: "stk",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div>{numberFormatter(Math.floor(cellInfo.cell.row.original.stk).toString())}</div>}
        </>
      },
      {
        Header: "淨資產",
        accessor: "nat",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div>{numberFormatter(Math.floor(cellInfo.cell.row.original.nat).toString())}</div>}
        </>
      },
      {
        Header: "獲利",
        accessor: "pf",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx(cellInfo.cell.row.original.pf > 0 ? "red" : cellInfo.cell.row.original.pf < 0 ? "green" : "")}>{numberFormatter(Math.round(cellInfo.cell.row.original.pf).toString())}</div>}
        </>
      },
      {
        Header: "報酬率(%)",
        accessor: "roi",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx(cellInfo.cell.row.original.roi > 0 ? "red" : cellInfo.cell.row.original.roi < 0 ? "green" : "")}>{numberFormatter((cellInfo.cell.row.original.roi).toString())}</div>}
        </>
      },
    ],
    []
  );

  const inv_columns = React.useMemo<Column<invType>[]>(
    () => [
      {
        Header: <><div className={cx("tableHeadAction")} >選項</div></>,
        accessor: "action",
        sticky: "left",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx("btn-group", "tableHeadAction")} style={{ flexWrap: "wrap", margin: "auto" }}>
            <button className={cx("btn", "red")} style={{ marginBottom: "5px" }} onClick={() => { handleOrder(cellInfo.cell.row.original, "B") }}>買入</button>
            <button className={cx("btn", "green")} onClick={() => { handleOrder(cellInfo.cell.row.original, "S") }}>賣出</button>
          </div>}
        </>
      },
      {
        Header: <><div className={cx("tableHeadwrap")}>權證名稱</div></>,
        accessor: "name",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx("tableHeadwrap")}>{cellInfo.cell.row.original.name && cellInfo.cell.row.original.name || "--"}</div>}
        </>
      },
      {
        Header: <><div style={{ width: "95px", margin: "auto" }}>權證代號</div></>,
        accessor: "sym",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div style={{ width: "95px", margin: "auto" }}>{cellInfo.cell.row.original.sym && cellInfo.cell.row.original.sym || "--"}</div>}
        </>
      },
      {
        Header: <><div style={{ width: "75px", margin: "auto" }}>張數</div></>,
        accessor: "qty",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div style={{ width: "75px", margin: "auto" }}>{cellInfo.cell.row.original.qty && cellInfo.cell.row.original.qty || "--"}</div>}
        </>
      },
      {
        Header: <><div className={cx("tableHeadwrap")}>買賣均價<br />買價<span className={cx("unit")}>(元)</span></div></>,
        accessor: "pa",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<><div>{numberFormatter(cellInfo.cell.row.original.pa.toString())}<br />{cellInfo.cell.row.original.pc && numberFormatter(cellInfo.cell.row.original.pc.toString()) || "--"}</div></>}
        </>
      },
      {
        Header: <><div className={cx("tableHeadwrap")}>買入成本<br />市值<span className={cx("unit")}>(元)</span></div></>,
        accessor: "bc",
        disableSortBy: true,
        Cell: cellInfo => <>
          {cellInfo.cell.row.original.bc && numberFormatter(cellInfo.cell.row.original.bc.toString()) || "--"}<br />{cellInfo.cell.row.original.mV2 && numberFormatter(Math.floor(cellInfo.cell.row.original.mV2).toString()) || "--"}
        </>
      },
      {
        Header: <><div style={{ width: "80px", margin: "auto" }}>剩餘天數</div></>,
        accessor: "sd",
        disableSortBy: true,
        Cell: cellInfo =>
          <div style={{ width: "80px", margin: "auto" }}>{cellInfo.cell.row.original.sd && cellInfo.cell.row.original.sd || "--"} {cellInfo.cell.row.original.sd && Number(cellInfo.cell.row.original.sd) <= 10 &&
            <LastDayTip name={cellInfo.cell.row.original.name} day={cellInfo.cell.row.original.sd} sym={cellInfo.cell.row.original.name} todayDate={todayDate}></LastDayTip>
          }
          </div>
      },
      {
        Header: <><div className={cx("tableHeadwrap")}>損益</div></>,
        accessor: "pf",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx("tableHeadwrap", cellInfo.cell.row.original.pf > 0 ? "red" : cellInfo.cell.row.original.pf < 0 ? "green" : "")}>{cellInfo.cell.row.original.pf && numberFormatter(Math.round(cellInfo.cell.row.original.pf).toString()) || "--"}</div>}
        </>
      },
      {
        Header: <><div style={{ width: "80px", margin: "auto" }}>報酬率<span className={cx("unit")}>(%)</span></div></>,
        accessor: "roi",
        disableSortBy: true,
        Cell: cellInfo => <>
          {<div className={cx(cellInfo.cell.row.original.roi > 0 ? "red" : cellInfo.cell.row.original.roi < 0 ? "green" : "")} style={{ width: "80px", margin: "auto" }}> {cellInfo.cell.row.original.roi && numberFormatter(cellInfo.cell.row.original.roi.toString()) || "--"}</div>
          }
        </>
      },
    ],
    [campaign_active]
  );

  React.useEffect(() => {
    handleOninvitationCode(invitation);
    (window.parent as any).resizeIframe();
  }, [invitation, valueyLoading, invDate])

  return (
    <div className={cx("page-tradAccount")}>
      <Container className={cx("container-left")} fluid>
        <div className={cx("text-color", "container-left", 'marginy-3px')}>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>
          目前盤別：{campaignName ? campaignName : "尚未選擇活動"}
        </div>
        <SchoolCampaignReminder joinSC={joinSC} />
        <div className={cx("text-color", "container-left", 'marginy-3px')}>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>

          <span className={cx("badge-box-none")}>權證贏家</span>
          <span className={cx("badge-username")} >{userName}</span>
        </div>
        {(campaignName !== "權民大擂台" && campaignName !== "校園課程" ) && (
          <div className={cx("text-color", "container-left", 'marginy-3px')} style={{ display: "flex", paddingBottom: "5px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color")} viewBox="0 0 16 16" style={{ margin: "auto 0" }}>
              <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
            </svg>
            <div style={{ margin: "auto 0" }}> 資產總計</div>
            <Button className={cx("asset-btn", "income")} onClick={() => { handleOpenAlert("income") }}>入金</Button>
            <Button className={cx("asset-btn", "reset")} onClick={() => { handleOpenAlert("reset") }}>重置帳戶</Button>
          </div>
        )}
        <Table columns={user_status_columns} data={assetDate} pagination={false} loading={OnhandLoading && !invDate} />
        <div>◎ 模擬交易平台提供您『20萬元模擬金』練習權證交易，累積投資實戰力。</div>

        <div className={cx("text-color", "container-left", "invWarp")}>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="text-color bi bi-play" viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>
          我的邀請碼:{valueyLoading ? <Spinner animation="border" /> : invitation ? invitation : "尚無邀請碼"}
        </div>
 {showTip && (
  <div className={cx("text-color", "container-left")}>
    &nbsp;&nbsp;&nbsp;↑此為好友邀請碼，並非教授邀請碼。
  </div>
)}

        {
          invitation && <div className={cx("share-wrap")}>
            <CopyToClipboard text={invitation} onCopy={() => {
            }}>
              <Button className={cx("asset-btn", "invBtn")}  >複製邀請碼</Button>
            </CopyToClipboard>
            <FacebookShareButton
              className={cx("share-btn")}
              url={shareUrl}
              quote={title}
            >
              <FacebookShare />
            </FacebookShareButton>
            <LineShareButton
              className={cx("")}
              url={shareUrl}
              title={title}
            >
              <LineShare />
            </LineShareButton>
          </div>
        }

        <div className={cx("text-color", "container-left")}>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
            <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
          </svg>
          庫存清單  <Badge className={cx("badge-box")}>{invDate.length}筆</Badge>
        </div>
        <div className={cx("updateTime")}>
          更新時間：{queryTime || ""}
        </div>

        <div className={cx('tableHead-minHeight')}>
          <Table columns={inv_columns} loading={OnhandLoading && !invDate} data={invDate} pagination={true} renderPage="inv_columns" />
        </div>

        <ul className={cx("list-decimal", "text-secondary", "small")}>
          Tip:
          <li>「買賣均價」計算公式：SUM每筆(買入價 × 買入張數+買入手續費 ) / 庫存股數。</li>
          <li>「買入成本」計算公式：(買入價 × 買入張數 ×  1000)。</li>
          <li>「市值」計算公式：(買價 × 庫存張數 × 1000 ) - ( 買價 × 庫存張數 × 1000 × 手續費率) - ( 買價 × 庫存張數 × 1000 × 交易稅率 )。</li>
          <li>手續費買賣皆收，以買入價及賣出價的0.1425%計算，未滿20元按20元計收。</li>
          <li>交易稅賣出時計收，以賣出價的0.1%計算。</li>
        </ul>
        <OrderModel
          isOpen={show}
          mtype={mtype}
          sessionId={sessionId}
          handleClose={handleClose}
          symCnName={symCnName}
          handleSymCnName={(name) => { setSymCnName(name) }}
          sym={sym}
          handleSym={(sym) => { setSym(sym) }}

          buyOrSell={bS1}
          handleBuyOrSell={(bs) => { setBS1(bs) }}


          orderPriceType={ort}
          handleOrderPriceType={(type) => { handlePriceType(type) }}
          orderTime={tif}
          handleOrderTime={(tif) => { setTif(tif) }}

          price={p1 || 0}
          handleOrderPrice={(price) => { handlePrice(price) }}

          qty={qty || 0}
          handleOrderQty={(qty) => { setQty(qty) }}

          handleOrderPlace={() => { handleOrderPlace() }}
          target_money={target_money}
          target_upprice={t_up_stop}
          target_downprice={t_down_stop}
        />

        <AleartModel
          isOpen={openAlertModel}
          handleClose={() => setOpenAlertModel(false)}
          handleCheck={() => { handleAlert() }}
          type={alertType}
        />

        <ShareModel
          isOpen={showinviteModel}
          handleClose={() => setShowinviteModel(false)}
          istop6K={istop6K}
          invitationCode={invitationCode}
          isPrize={null}
        />
           <Modal show={showWelcomeModal} onHide={handleCloseWelcomeModal}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
  <p>此活動 <span style={{ color: 'red' , fontSize: '20px' , fontWeight: 'bolder' }}>不提供</span> 入金與重置功能</p>
</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseWelcomeModal}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
      </Container>
    </div>
  );
};

export default Account;
